
<template>
  <AutoComplete
    unstyled
    emptySearchMessage="Nenhum resultado encontrado"
    :suggestions="suggestions"
    :pt="{
      root: ({ state }) => ({
        class: [
          'rounded flex flex-row gap-x-1 items-center w-full dark:bg-slate-700',
          state.focused ? focusClass:'',
          transitionClass,
          borderClass
        ]
      }),
      input: {
        class: [
          'rounded outline-0 w-full dark:bg-slate-700',
          paddingClass,
          textClass
        ]
      },
      item: {
        class: [
          'flex flex-row px-2 py-[2px] transition-all last:rounded-b hover:bg-gray-500/10 cursor-pointer',
          textClass
        ]
      },
      panel: {
        class: [
          panelClass,
          suggestions.length == 0 ? 'text-center text-xs':''
        ]
      },
      token: {
        class: [
          'rounded-full bg-theme/20 text-white flex flex-row items-center gap-x-1 px-1 py-[2px]'
        ]
      }
    }"
  >
    <template #loadingicon>
      <div class="mr-3">
        <RpmSpinner
          size="h-[18px] w-[18px]"
          border="border-3"
        />
      </div>
    </template>
  </AutoComplete>
</template>

<script>

import AutoComplete from 'primevue/autocomplete';
import RpmSpinner from "#components/RpmSpinner.vue";

export default {
  name: "RpmAutoCompleteInput",
  components: {
    AutoComplete,
    RpmSpinner
  },
  props: {
    focusClass: {
      type: String,
      default: ""
    },
    borderClass: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
    transitionClass: {
      type: String,
      default: ""
    },
    panelClass: {
      type: String,
      default: ""
    },
    paddingClass: {
      type: String,
      default: ""
    },
    suggestions: {
      type: Array,
      default: []
    },
  }
};

</script>
